module.exports = __webpack_public_path__ + "img/fruit-peaches-350x184.44b93b2b.jpg";